export default {
    firstBlock: [
        { title: 'Flexible web solutions', subtitle: 'Cutting-edge technology', text: 'No matter how complex your project is, our experts can easily bring all your ideas to life.' },
        { title: 'Saas solutions', subtitle: 'Innovative methods', text: 'Our developers create sophisticated Saas solutions to help businesses operate more efficiently.' },
    ],
    secondBlock: [
        { title: 'Enterprise solutions', subtitle: 'Profound expertise', text: 'We create top-notch web products for enterprises, startups, and everything in between to help businesses thrive.' },
        { title: 'E-commerce solutions', subtitle: 'Business scalability', text: 'Our team develops customized e-commerce products that can easily scale with business growth and expansion.' },
    ]
}